import { usePublicProfileData } from '@/context/PublicProfileContext';
import { BadCraneDoodle } from '@/components/home/BadCraneDoodle';

// Shown in place of Releases/Shows/Platforms/Contact when a profile has none of
// that content yet — so a brand-new page reads as "still being built" rather
// than broken or abandoned.
export function ComingSoon() {
  const { profile } = usePublicProfileData();

  return (
    <>
      <div className="ap-divider" />
      <section className="ap-coming-soon">
        <BadCraneDoodle />
        <h2 className="ap-coming-soon__title">
          {profile.name} is still creating their page.
        </h2>
        <p className="ap-coming-soon__text">
          New stuff is on its way. Check back soon.
        </p>
      </section>
    </>
  );
}
